import Container from "@mui/material/Container";
import Grid from "@mui/material/Unstable_Grid2";
import React from "react";
import { useLoaderData, useNavigate } from "react-router-dom";
import Header from "../components/Header";
import FormDropDownAndUsed from "../components/form/FormDropDownAndUsed";
import Form from "../components/form/Form";
import { useForm, FormProvider } from "react-hook-form";
import FormButton from "../components/form/FormButton";
import { useMessage } from "../context/MessageProvider";
import { getAssessment } from "../models/assessments";
import { listAnimals } from "../models/animals";
import { getFacility } from "../models/facility";

import Subtitle from "../components/Subtitle";
import GoBack from "../components/GoBack";

import { findModel } from '../utils/model';

import {
  listSectionCsByAssessment,
  newSectionC,
  saveSectionC,
} from "../models/sectionc";
import { today } from "../utils/datetime";

import { useConnectivity } from "../context/ConnectivityProvider";

export async function loader({ params }) {
  console.log("sectionc params",params);

  const assessment = await getAssessment(params.assessmentId);
  const sectionCs = await listSectionCsByAssessment(assessment.id);

  return {
    assessment,
    animals: await listAnimals(),
    newSectionC: newSectionC(),
    facility: await getFacility(),
    sectionCs,
  };
}

export default function AssessmentSectionCSelectPage({ title = "EWP", ...props }) {

    const { setSuccess, setError } = useMessage();
    const navigate = useNavigate();
    const { assessment, sectionCs, animals } = useLoaderData();

    const animal = findModel(animals,assessment.animal_id);

    const { isOnline } = useConnectivity();


    const hasInprogressRecords = (sectionCs.filter((cur)=>{
        return cur.observed_on && !cur.submitted_on
    }).length) ? true : false;
    console.log(hasInprogressRecords);


    const sectionList = sectionCs.map((cur)=>{
        return {
            value: cur.id,
            label: cur.observation_range,
        }
    });



    // generate a used list out of the submitted sectionCs
    const usedList = sectionCs.filter((cur)=>{
        return cur.submitted_on;
    }).map((cur)=>{
        return cur.id;
    });




    const methods = useForm({ defaultValues: { id: '' } });

    const onSubmit = async (data)=>{
        try {

        console.log("onSubmit: ", data);

        const record = sectionCs.find((cur)=>cur.id === data.id);
        if (record === null) {
            throw new Error("Could not locate a section record with id: " + data.id);
        }

        const payload = {...record,observed_on: today()};
        console.log("payload: ", payload);
        const saveResult = await saveSectionC(payload,isOnline);
        console.log("sectionc save: ", saveResult);

        setSuccess("Started Section C");
        navigate("/assessments/" + assessment.id + "/sectionc/" + record.id);

        /*
        const matchedSectionC = sectionCs.filter((cur)=>{
            return data.observation_range === cur.observation_range;
        });

        console.log("matchedSectionC ", matchedSectionC);

        if (matchedSectionC.length > 1) {
            throw new Error("An issue exists with the section C, two or more records are using the same observation range");
        } else if (matchedSectionC.length === 1) {
            const existingSectionC = matchedSectionC[0];
            setSuccess("Started Section C");
            navigate("/assessments/" + assessment.id + "/sectionc/" + existingSectionC.id);
        } else {

            const payload = {...newSectionC,...data,observed_on: today(), assessment_id: assessment.id, user_id: user.id};
            console.log("payload: ", payload);

            const saveResult = await saveSectionC(payload,isOnline);
            console.log("sectiona save: ", saveResult);

            setSuccess("Started Section C");
            navigate("/assessments/" + assessment.id + "/sectionc/" + saveResult.id);

        }
        */

        } catch (error) {
            console.error(error);
            setError(error.message);
        }
    }

    return (
        <Container component="main" maxWidth="sm">
            <GoBack onClick={()=>navigate(`/assessments/${assessment.id}`)} />
            <Header label={title} />
            <Subtitle>{assessment?.assessment_title || animal?.name}</Subtitle>

            <FormProvider {...methods}>
                <Form onSubmit={methods.handleSubmit(onSubmit)}>
                    <Grid container spacing={2}>
                        <Grid xs={12} sm={12} sx={{justifyContent: "center", alignItems: "center"}}> 
                            <FormDropDownAndUsed name="id" label="Observation Timeframe" list={sectionList} required usedList={usedList} />
                        </Grid>

                        <Grid xs={12} sm={12}> 
                            <FormButton>Start</FormButton>
                        </Grid>
                    </Grid>

                </Form>
            </FormProvider>
        </Container>

    );
}
